module.exports = __webpack_public_path__ + "static/media/studio-slide8.4f99ee96.png";